import { createSelector } from "@reduxjs/toolkit";

const sceneState = (state) => state.scene;
const sessionState = (state) => state.session;

export const selectSpawnPoint = createSelector(sceneState, (scene) => scene.spawnPoint);

export const selectColor = createSelector(sceneState, (scene) => scene.color);

export const selectSpawnRotation = createSelector(sceneState, (scene) => scene.spawnRotation);

export const selectIsConnected = createSelector(sessionState, (session) => session.isConnected);

export const selectIsShowingInfoModal = createSelector(sessionState, (session) => session.isShowingInfoModal);

export const selectIsShowingHelpOverlay = createSelector(sessionState, (session) => session.isShowingOverlay);

export const selectUsers = createSelector(sceneState, (scene) => scene.users);

export const selectAvailableElements = createSelector([sceneState, sessionState], (scene, session) => {
  if (session.isTryingRoom) {
    return session.trialScene.elements.filter((el) => el.isEnabled);
  } else {
    return scene.elements.filter((el) => el.isEnabled && (!el.isGrabbed || el.owner === session.id));
  }
});

export const selectScaling = createSelector(sceneState, (scene) => scene.scaling);

export const selectRenderScale = createSelector(sceneState, (scene) => scene.renderScale);

export const selectGrabbingPermission = createSelector(sceneState, (scene) => scene.canIGrab);

export const selectisInVR = createSelector(sceneState, (scene) => scene.isInVR);

export const selectSessionType = createSelector(sessionState, (session) => session.sessionType);

export const selectisInTrialMode = createSelector(sessionState, (session) => session.isTryingRoom);

export const selectisTyping = createSelector(sessionState, (session) => session.isTyping);

export const selectMultipleGrabbingPermission = createSelector(sceneState, (scene) => scene.canGrabMultipleObjs);

export const selectSceneStats = createSelector(sceneState, (scene) => ({
  users: scene.users.length,
  elements: scene.elements.length,
}));

export const selectAtomRadius = createSelector(sceneState, (scene) => scene.pdb.radius);

export const selectPdb = createSelector(sceneState, (scene) => scene.pdb);

export const selectAtomRadiusScale = createSelector(sceneState, (scene) => scene.atomRadiusScale);

export const selectStickRadiusScale = createSelector(sceneState, (scene) => scene.stickRadiusScale);

export const selectSimState = createSelector(sessionState, (session) => session.isSimOn);

export const selectIsOrbit = createSelector(sceneState, (scene) => scene.isOrbitControls);

export const selectMyId = createSelector(sessionState, (session) => session.id);

export const selectisMinimizing = createSelector(sessionState, (session) => session.sessionStatus === "MINIMIZING");

// Gimbal selectors
export const selectGimbalOwner = createSelector(sceneState, (scene) => scene.gimbalOwner);

export const selectIsGimbalGrabbed = createSelector(sceneState, (scene) => scene.isGimbalGrabbed);